import { ChevronDown } from "lucide-react";
import HelpQ from "./HelpQ";
import { writeDraggedChatContext } from "../utils/chatContextDrag";

function AppRightRailAssessment({
  open,
  assessments,
  highlightedAssessmentIds,
  activeSummaryId,
  chatContextPickMode,
  onToggle,
  onOpenAssessment,
  styles,
}) {
  return (
    <section className={styles.rightRailSection} data-tour-id="assessments">
      <button
        type="button"
        className={`${styles.rightRailSectionHeader} ${
          open ? styles.rightRailSectionHeaderOpen : ""
        }`}
        onClick={onToggle}
      >
        <span className={styles.rightRailSectionHeaderTitle}>Assessments</span>
        <span className={styles.rightRailSectionHeaderActions}>
          <HelpQ stepIndex={3} title="What are assessments?" />
          <ChevronDown size={12} strokeWidth={2} aria-hidden="true" />
        </span>
      </button>
      {open ? (
        <div className={styles.rightRailSectionBody}>
          {assessments.map((item) => (
            <button
              key={item.id}
              type="button"
              className={`${styles.rightRailAssessmentItem} ${
                highlightedAssessmentIds.has(item.id)
                  ? styles.rightRailAssessmentItemActive
                  : ""
              } ${
                activeSummaryId === item.id
                  ? styles.rightRailAssessmentItemSelected
                  : ""
              } ${
                !item.latestUpdatedAt ? styles.rightRailItemDisabled : ""
              } ${
                chatContextPickMode && item.latestUpdatedAt
                  ? styles.rightRailItemWiggle
                  : ""
              }`}
              onClick={() => {
                if (!item.latestUpdatedAt) return;
                onOpenAssessment(item);
              }}
              disabled={!item.latestUpdatedAt}
              draggable={Boolean(chatContextPickMode && item.latestUpdatedAt)}
              onDragStart={(event) =>
                writeDraggedChatContext(event, {
                  key: item.id,
                  label: item.label,
                  type: "assessment",
                  source: "assessment",
                  sourceLabel: "Assessment",
                })
              }
              data-tour-id={item.id === "business" ? "biz-assessment" : undefined}
            >
              <span className={styles.rightRailAssessmentLeft}>
                <span className={styles.rightRailAssessmentName}>{item.label}</span>
              </span>
              <span className={styles.rightRailAssessmentMeta}>
                {item.meta || "Not generated yet"}
              </span>
            </button>
          ))}
        </div>
      ) : null}
    </section>
  );
}

export default AppRightRailAssessment;
